const ENDPOINT = 'POSTlogout';
function postLogout(gateway, params) {
    return gateway.post(postLogout.endpoint, params, params);
}
postLogout.endpoint = ENDPOINT;

export { postLogout as default };
//# sourceMappingURL=postLogout.js.map
